import CreationBannerData from "../../model/creators/creationBannerData";
import RecommendMaterialGroup from "../../model/creators/recommendMaterialData";
import { Api, MethodType, RequestType, ResponseType } from "../define";

// リクエスト
export type Request = RequestType & {
}

// レスポンス
export type Response = ResponseType & {
    creationList: CreationBannerData[],
    materialGroupList: RecommendMaterialGroup[],
}

export default class CreatorPageApi extends Api<Request, Response>{
    // リクエストURL
    public url = `${process.env.REACT_APP_URL}/webSite/CreatorPageInfo`; 

    // リクエストパラメータ
    public request: Request;

    // コンストラクター
    constructor(request: Request) {
        super(request);
        this.request = request;
        this.method = MethodType.POST;
    }

    // レスポンスパース処理
    public parseResponse(data: any): Response {
        return data;
    }
}